import { render } from "./FormRadio.vue?vue&type=template&id=32f5f9e2&scoped=true"
import script from "./FormRadio.vue?vue&type=script&lang=js"
export * from "./FormRadio.vue?vue&type=script&lang=js"

import "./FormRadio.vue?vue&type=style&index=0&id=32f5f9e2&scoped=true&lang=css"

import exportComponent from "/Users/rs/Development/alisops/aclu-sdic-ice-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f5f9e2"]])

export default __exports__